/*
 * Spotify page - missing-track warning (Daniela / Rodrigo, 2026-10-02).
 *
 * The track search sits in its own column - below the packages on mobile - while the sticky
 * mobile bar offers "Add to cart" from page load, so many buyers reached checkout without ever
 * seeing it and orders arrived with no Spotify link. The first Add to cart without a track shows
 * a warning with an "Add your song" shortcut; pressing Add to cart again continues, because a
 * buyer may genuinely not have a link yet (an unreleased song) and the sale must not be blocked.
 *
 * Loaded by the ygpc purchase widget (custom_liquid_HaRBX4) in templates/page.spotify-page.json
 * and both page.spotify-v2-*.json variants. It lives here rather than inline because Shopify caps
 * a custom_liquid setting at 50 KB and the widget is already close to that.
 *
 * It touches the widget only through the DOM: a capture-phase submit listener on the document runs
 * before the widget's own handler on #ygpc-form, and "a track is chosen" is the widget's
 * #ygpc-track-selected.visible state (set by setTrack / setTrackFromUrl, removed by clearTrack).
 */
(function () {
  var TEXT = "No track link added yet. If that's on purpose (e.g. your song isn't out yet), no problem. We'll just need it before your campaign can start.";
  var ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex:0 0 18px;margin-top:1px"><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"></path><path d="M12 9v4"></path><path d="M12 17h.01"></path></svg>';

  var warned = false;
  var inlineEl = null;
  var barEl = null;

  function byId(id) { return document.getElementById(id); }

  function hasTrack() {
    var sel = byId('ygpc-track-selected');
    return !!(sel && sel.classList.contains('visible'));
  }

  function fromMobileBar(e) {
    if (e && e.submitter) { return e.submitter.id === 'ygpc-mb-btn'; }
    return !!(byId('ygpc-mobile-bar') && window.matchMedia && window.matchMedia('(max-width: 820px)').matches);
  }

  function goToTrackSearch() {
    if (barEl) { barEl.style.display = 'none'; }
    var input = byId('ygpc-search-input');
    if (!input) { return; }
    var card = input.closest('.ygpc-search-card');
    if (card && card.scrollIntoView) { card.scrollIntoView({ block: 'center' }); }
    /* Focus inside the tap itself, so iOS opens the keyboard. */
    try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
    var prev = input.style.boxShadow;
    input.style.boxShadow = '0 0 0 3px rgba(242,196,109,.85)';
    setTimeout(function () { input.style.boxShadow = prev; }, 1800);
  }

  function build(id, floating) {
    var el = document.createElement('div');
    el.id = id;
    el.setAttribute('role', 'alert');
    el.style.cssText =
      'display:none;gap:10px;align-items:flex-start;padding:12px 14px;border-radius:10px;' +
      'background:#FFF7E6;border:1px solid #F2C46D;color:#7A4A00;text-align:left;' +
      'font-size:13px;line-height:1.45;font-weight:600;box-sizing:border-box;' +
      (floating
        ? 'position:fixed;left:12px;right:12px;z-index:2147483000;box-shadow:0 8px 24px rgba(0,0,0,.18);'
        : 'margin:0 0 12px;');
    el.innerHTML = ICON;
    var body = document.createElement('div');
    body.style.cssText = 'flex:1;min-width:0;';
    var txt = document.createElement('div');
    txt.textContent = TEXT;
    var add = document.createElement('button');
    add.type = 'button';
    add.textContent = 'Add your song';
    add.style.cssText =
      'margin-top:9px;background:#1a1a1a;color:#fff;border:0;border-radius:8px;padding:8px 13px;' +
      'font:inherit;font-size:12.5px;font-weight:700;cursor:pointer;';
    add.addEventListener('click', goToTrackSearch);
    body.appendChild(txt);
    body.appendChild(add);
    el.appendChild(body);
    if (floating) {
      var x = document.createElement('button');
      x.type = 'button';
      x.setAttribute('aria-label', 'Dismiss');
      x.textContent = '×';
      x.style.cssText =
        'flex:0 0 auto;background:none;border:0;color:#7A4A00;font-size:20px;line-height:1;' +
        'padding:0 2px;margin:-3px -4px 0 0;cursor:pointer;';
      x.addEventListener('click', function () { el.style.display = 'none'; });
      el.appendChild(x);
    }
    return el;
  }

  function show(fromBar) {
    var atcBtn = byId('ygpc-atc-btn');
    if (!inlineEl) {
      inlineEl = build('ygpc-url-alert', false);
      if (atcBtn && atcBtn.parentNode) { atcBtn.parentNode.insertBefore(inlineEl, atcBtn); }
    }
    inlineEl.style.display = 'flex';
    /* On mobile the sticky bar is where the tap happened - show it right above the bar too.
       Fixed to the page with a high z-index so third-party launchers (Rewards) can't cover it. */
    var mobileBar = byId('ygpc-mobile-bar');
    if (fromBar && mobileBar) {
      if (!barEl) {
        barEl = build('ygpc-url-alert-bar', true);
        document.body.appendChild(barEl);
      }
      barEl.style.bottom = (mobileBar.getBoundingClientRect().height + 8) + 'px';
      barEl.style.display = 'flex';
    }
  }

  function hide() {
    warned = false;
    if (inlineEl) { inlineEl.style.display = 'none'; }
    if (barEl) { barEl.style.display = 'none'; }
  }

  document.addEventListener('submit', function (e) {
    if (!e.target || e.target.id !== 'ygpc-form') { return; }
    if (hasTrack() || warned) { return; }
    warned = true;
    e.preventDefault();
    e.stopImmediatePropagation();
    show(fromMobileBar(e));
  }, true);

  /* Clear the warning the moment a track is chosen, by search or by pasting a URL. */
  function watchTrack() {
    var sel = byId('ygpc-track-selected');
    if (!sel || !window.MutationObserver) { return; }
    new MutationObserver(function () { if (hasTrack()) { hide(); } })
      .observe(sel, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchTrack);
  } else {
    watchTrack();
  }
})();
